import { useGenUiConfig } from '../../shared/ui/config.js';
import type { FlightPlannerPort } from '@voll-intelligence/genui-contract';

// `config.tsx` importa o tipo `FlightPlannerPort` daqui via airport_view; este
// arquivo expõe só o hook (React) — o tipo é re-exportado pra conveniência.
export type { FlightPlannerPort } from '@voll-intelligence/genui-contract';

/** Lê o port `flightPlanner` do Context. `null` quando o host não o injeta. */
export function useFlightPlannerPort(): FlightPlannerPort | null {
  return useGenUiConfig().ports?.flightPlanner ?? null;
}
